// React
import React from 'react'
// Components
import Button from '../Display/Button'
import Logo from '../Display/Logo'

export default class Welcome extends React.Component {

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	render() {
		return (
			<div className='capps-container'>
				<div className='capps-responsive'>
					<Logo {...this.props} />
					<div className='capps-height-20' />
					<div className='capps-form'>
						Please first enter your personal information (under the “my sign” tab). Once you’ve done that, you can read about your moon sign compatibility with your contacts.
					</div>
					<div className='capps-height-10' />
					<Button
						action={() => {
							setTimeout(() => {
								if (this.props.state.nav.length > 1) {
									this.props.redux.nav.removePage()
								}
								else {
									this.props.redux.nav.setPage('')
								}
							}, 20)
						}}
						text='Continue'
					/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Pages/PersonalInfo.js